export default __webpack_public_path__ + "static/media/background.32325e37.jpg";